module.exports = __webpack_public_path__ + "resources/img/img_watchall_dbms_02_m.9ee09f14ac6371244b9a3f9cf58d0367.png";